<app-header></app-header>
<div class="content-container">
  <router-outlet></router-outlet>
</div>
<app-footer></app-footer>
